module.exports = __webpack_public_path__ + "img/assess-main.1ff081d.png";